import React, { createContext, useContext, useEffect, useState } from "react";

// Base is USD. Rates are indicative; supplier quotes always confirm.
const RATES = {
  USD: { rate: 1, symbol: "$", flag: "🇺🇸" },
  AUD: { rate: 1.52, symbol: "A$", flag: "🇦🇺" },
  NZD: { rate: 1.65, symbol: "NZ$", flag: "🇳🇿" },
  GBP: { rate: 0.79, symbol: "£", flag: "🇬🇧" },
  EUR: { rate: 0.92, symbol: "€", flag: "🇪🇺" },
};

const CurrencyCtx = createContext(null);

export function CurrencyProvider({ children }) {
  const [code, setCode] = useState(() => localStorage.getItem("currency") || "USD");
  useEffect(() => { localStorage.setItem("currency", code); }, [code]);

  const convert = (amountUsd) => {
    if (amountUsd == null || isNaN(amountUsd)) return null;
    return amountUsd * RATES[code].rate;
  };

  const format = (amountUsd) => {
    const converted = convert(amountUsd);
    if (converted == null) return null;
    const rounded = converted >= 100 ? Math.round(converted) : (Math.round(converted * 100) / 100);
    return `${RATES[code].symbol}${rounded.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
  };

  const formatRange = (min, max, singlePrice) => {
    if (min != null && max != null) return `${format(min)} – ${format(max)} ${code}`;
    if (min != null) return `${format(min)}+ ${code}`;
    if (max != null) return `Up to ${format(max)} ${code}`;
    if (singlePrice != null) return `${format(singlePrice)} ${code}`;
    return null;
  };

  return (
    <CurrencyCtx.Provider value={{ code, setCode, options: Object.keys(RATES), rates: RATES, convert, format, formatRange }}>
      {children}
    </CurrencyCtx.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyCtx);
